import { render, staticRenderFns } from "./AddEditUser.vue?vue&type=template&id=5062b71a&scoped=true"
import script from "./AddEditUser.vue?vue&type=script&lang=js"
export * from "./AddEditUser.vue?vue&type=script&lang=js"
import style0 from "./AddEditUser.vue?vue&type=style&index=0&id=5062b71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062b71a",
  null
  
)

export default component.exports